export default __webpack_public_path__ + "locales/lo-LA/InviteDialog.json?hash=90672937c719c9149fe2202111e584b5";